import { Injectable } from "@angular/core";
import { ListMetadata } from "app/models/list-metadata.model";
import { HttpClientService } from "app/services/httpClient/httpclient.service";
import { Observable } from "rxjs";
import { ChallengeDetail, ChallengeDetailElaborated, ChallengePeriodOverviewChartesian, ChallengeResponse, GraphicsDTO, GraphicsDTOChartesian, OverviewPartecipantsDTO, OverviewPayload, ParticipantOverview, ParticipantOverviewResponse, ParticipantsOverviewSummary, SaveChallengeDto } from "./challenge.model";
import { PremioDTO } from "./gifts/gifts-edit-create.component";
import { AcmTypehasReason } from "app/models/loyalty-acm-type.model";
import { HttpParams } from "@angular/common/http";
import { ChallengeDetailTotalResponse, ChallengeEditResponse } from "./challenge-creation/challenge-creation.component";
import { ReachedLevel } from "../customerDB/customers/challenge/challenge-3-kontable/challenge-3-kontable.component";
import { forkJoin } from "rxjs/observable/forkJoin";
import { ChallengeTemplate } from "app/models/challenge-template";
import { Touchpoint } from "../campaign-3/models/campaign-3.model";

@Injectable()
export class ChallengeOverviewService {

 
partecipantOverviewURL= "/k7o/gui-shim/loy/challenge/challenge-api/overview"


  constructor(private http: HttpClientService) { }


private overviewFilters: OverviewPartecipantsDTO | null = null;

setOverviewFilters(filters: OverviewPartecipantsDTO): void {
  this.overviewFilters = filters;
}
 
  
  //----------------CRUD GRAFCI------------------------                            ---
  private graphicBaseUrl = '/k7o/gui-shim/loy/challenge/challenge-api/overview';

list(
  offset: number | null = null,
  limit: number | null = null,
  search?: Array<{ key: string; value: string }>,
  globalSearch?: string,
  sort?: string,
  sort_dir?: number
): Observable<{ data: ChallengeResponse[]; metadata: ListMetadata }> {

  if (!this.overviewFilters) {
    throw new Error('Overview filters not set');
  }

  const params = HttpClientService.buildListParams(
    offset,
    limit,
    search,
    globalSearch,
    sort,
    sort_dir
  );

  const body = {
    ...this.overviewFilters
  };

  const paramsString = params.toString().replace(/\+/g, '%2B');

  return this.http.postPaged(
    `${this.partecipantOverviewURL}/participants?${paramsString}`,
    body
  );
}

downloadExcell(
  offset: number | null = null,
  limit: number | null = null,
  search?: Array<{ key: string; value: string }>
) {
  if (!this.overviewFilters) {
    throw new Error('Overview filters not set');
  }

  const params = HttpClientService.buildListParams(
    offset,
    limit,
    search
  );

  const body = {
    ...this.overviewFilters
  };

  const paramsString = params.toString().replace(/\+/g, '%2B');

  return this.http.post(
    this.graphicBaseUrl + '/participants/export?' + paramsString,
    body,
    { responseType: 'blob' as 'json' }
  );
}

  // 2) Overview Participants Export
  exportOverviewParticipants(payload: OverviewPayload): Observable<Blob> {
    return this.http.post(
      `${this.graphicBaseUrl}/participants/export`,
      payload,
      { responseType: 'blob' as 'json' }
    );
  }

  // 3) Overview Complete
  getOverviewComplete(payload: GraphicsDTO): Observable<ParticipantsOverviewSummary> {
    return this.http.post(
      `${this.graphicBaseUrl}/complete`,
      payload
    );
  }
    getOverviewCompleteCartesian(payload: GraphicsDTOChartesian): Observable<ChallengePeriodOverviewChartesian> {
    return this.http.post(
      `${this.graphicBaseUrl}/completeByPeriod`,
      payload
    );
  }


  // 4) Overview Complete Export
  exportOverviewComplete(payload: GraphicsDTO): Observable<any> {
    return this.http.post(
      `${this.graphicBaseUrl}/complete/export`,
      payload,
      { responseType: 'blob' as 'json' }
    );
  }



  //Chiamate per Pubblicazione
publishUrl =  '/k7o/gui-shim/loy/challenge/challenge/publish';

  // PUBLISH
publishChallenge(challengeId: number): Observable<any> {
  return this.http.post(
    `${this.publishUrl}?challengeId=${challengeId}`,
    {}
  );
}
unPublishUrl =  '/k7o/gui-shim/loy/challenge/challenge/undoPublish';
// UNDO PUBLISH
undoPublishChallenge(challengeId: number): Observable<any> {
  return this.http.post(
    `${this.unPublishUrl}?challengeId=${challengeId}`,
    {}
  );
}


//overviewPartecipants

challengeService

}



// WEBPACK FOOTER //
// ./src/app/views/challenge/challenge-overview.service.ts